import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Empty } from "@/components/Page";
import { Button } from "@/components/ui/button";
import { FolderOpen, ArrowRight, FileText } from "lucide-react";

export default function Evidence() {
  const nav = useNavigate();
  const [epds, setEpds] = useState(null);
  useEffect(() => { api.get("/epds").then(({ data }) => setEpds(data)); }, []);

  return (
    <div>
      <PageHeader title="Data & Evidence" subtitle="Evidence repositories are held per EPD project. Open a project to upload and manage its supporting documents." />
      {epds && epds.length === 0 ? (
        <Empty icon={FolderOpen} title="No EPD projects yet" hint="Evidence is managed within each EPD project. Create an EPD to begin."
          action={<Button data-testid="empty-create-epd" onClick={() => nav("/app/epds")}><ArrowRight className="h-4 w-4 mr-1.5" /> Create EPD</Button>} />
      ) : (
        <div className="bg-white border rounded-lg overflow-hidden">
          <table className="w-full text-sm epn-table">
            <thead className="bg-slate-50 border-b"><tr className="text-left">
              <th className="px-5 py-2.5">EPD project</th><th className="px-5 py-2.5">Product</th>
              <th className="px-5 py-2.5">Category</th><th className="px-5 py-2.5 text-right">Evidence</th>
            </tr></thead>
            <tbody>
              {(epds || []).map((e) => (
                <tr key={e.id} className="border-b last:border-0">
                  <td className="px-5 py-3 font-medium">{e.name}</td>
                  <td className="px-5 py-3 text-slate-600">{e.product_name}</td>
                  <td className="px-5 py-3 text-slate-600">{e.category === "cement" ? "Cement" : "Ready-Mix"}</td>
                  <td className="px-5 py-3 text-right">
                    <Button size="sm" variant="ghost" data-testid={`evidence-open-${e.id}`} onClick={() => nav(`/app/epds/${e.id}?section=evidence`)}>
                      <FileText className="h-3.5 w-3.5 mr-1" /> Open evidence <ArrowRight className="h-3.5 w-3.5 ml-1" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
